module.exports = __webpack_public_path__ + "img/abc.2d3cc8d9.svg";